import React from 'react';

const TrainingDetailContainer: React.FunctionComponent = () => (
  <div>
      Training
  </div>
);

export default TrainingDetailContainer;
